export default class AgencyUserSummaryDto {
    firstNme = '';
    lastName = '';
    emailAddress = '';
}
